export const MASS_POSTING_START = 'MASS_POSTING_START';
export const MASS_POSTING_END = 'MASS_POSTING_END';
export const MASS_POSTING_RESULTS = 'MASS_POSTING_RESULTS';
export const RESET_MASS_POSTING = 'RESET_MASS_POSTING';
